import { Component } from '@mycolorway/tao';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import Cache from 'next/javascripts/modules/cache';
import CardRenderer from './card-renderer';

const resourceCardCache = new Cache();

Component('tr-resource-card', {
  mixins: [eventListenerMixin],

  properties: {
    type: String,
    item: Object,
    editing: Boolean,

    rendered: {
      type: Boolean,
      default: false,
    },
  },

  connected() {
    this.container = this.querySelector('.resource-card-content') || this;

    this.observeIntersection(() => {
      if (this.rendered) return;

      this.renderer = new CardRenderer({
        type: this.type,
        item: this.item,
        editing: this.editing,
      });

      const result = resourceCardCache.get(this.item.id);
      if (result) this.container.innerHTML = result;
      this.render();
    });
  },

  async render() {
    const result = await this.renderer.render();
    this.container.innerHTML = result;
    resourceCardCache.set(this.item.id, result);
    this.rendered = true;
  },

  observeIntersection(callback) {
    if (!window.IntersectionObserver) {
      callback.call(this);
      return;
    }

    this.observer = new IntersectionObserver(callback.bind(this), {
      rootMargin: '700px 0px 700px 0px',
    });
    this.observer.observe(this);
  },

  disconnected() {
    if (this.observer) this.observer.disconnect();
    if (this.renderer) this.renderer.abort();
    this.renderer = null;
  },
});
